import { Tag } from 'antd';
import React, { ReactElement } from 'react';
import { IDictionary } from '~utilities/IDictionary';
import InterestMethodEnum from '../../Api/Application/InterestMethodEnum';
import IApplication from '~Api/Application/IApplication';

const interestMethodClasses: IDictionary<string> = {
    [InterestMethodEnum.InterestMethod360]: 'day360',
    [InterestMethodEnum.InterestMethod365]: 'day365',
};

const interestMethodLabels: IDictionary<string> = {
    [InterestMethodEnum.InterestMethod360]: '360 Day',
    [InterestMethodEnum.InterestMethod365]: '365 Day',
};

export default function InterestMethodTag(props: {
    application: IApplication;
}): ReactElement {
    const { application } = props;

    return (
        <Tag className={`interest-method-tag ${interestMethodClasses[application.interestMethod]}`}>
            {interestMethodLabels[application.interestMethod]}
        </Tag>
    );
}